import React, { useState } from "react";

import { PointedText } from "../models";
import { useSettings } from "../utils/settings";
import { Chant } from "./Chant";
import { PlayableTitle } from "./audio/PlayableTitle";
import { TonePlayer } from "./audio/TonePlayer";

export const OrdPsalmSection: React.FC<{
    title: string;
    toneId: string;
    pointedText: PointedText;
    psalmNumber: number;
    firstVerse: number;
}> = (props) => {
    const { title, toneId, pointedText, psalmNumber, firstVerse } = props;

    const [modal, setModal] = useState(<></>);

    const id = title + toneId;

    const { settings } = useSettings();

    return (
        <div style={{}}>
            <PlayableTitle
                id={id}
                title={title}
                player={
                    <TonePlayer
                        tones={[toneId]}
                        id={title + toneId}
                        onSetModal={(id, element) => setModal(element)}
                        selectedTone={toneId}
                        onSetSelectedTone={(tone) => {}}
                    />
                }
            />
            <Chant
                pointedText={pointedText}
                boldMode="alternate"
                dropCap={true}
                exportLines={false}
                tone={toneId}
                onReportMistake={async (verseIndex) => {}}
            />
            {modal}
        </div>
    );
};
